import type { GetAppetiteAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetiteAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAppetiteAuditByIdArgs = {
  id: string;
};

export const useGetAppetiteAuditById = createQueryHook<
  UseGetAppetiteAuditByIdArgs,
  GetAppetiteAuditByIdQuery['appetite_audit'],
  GetAppetiteAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getAppetiteAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({ appetite_audit: data }),
  graphqlDocument: GetAppetiteAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
